export const clearAll = () => {
  if (typeof window === 'undefined') {
    return null
  }
  localStorage.clear()
  sessionStorage.clear()
}

// 🌐 Public API
//
// The auth tokens themselves are intentionally NOT stored here - they live in
// their own cookies (user_token / client_token / refresh_token, see
// src/utils/tokenStore.js). User profile, client-list, and selected-client
// data are likewise no longer cached here (see AuthContext, which re-fetches
// them from the backend on each boot and derives the selected client from
// the freshest last_visited_at instead) - this object only exists now for
// the storage-wide clear used on logout.
export const authStorage = {
  clearAuth: () => {
    // Flush out all memory completely
    localStorage.clear()
    sessionStorage.clear()
  }
}
